import { createAction, props } from "@ngrx/store";

export const set_notification_bar_data = createAction('SET_NOTIFICATION_BAR_DATA', props<any>());